import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/auth/Login';
import Dashboard from './pages/Dashboard';
import GraphView from './pages/GraphView';
import UserManagement from './pages/UserManagement';
import ResourceList from './components/crud/ResourceList';
import ResourceCreate from './components/crud/ResourceCreate';
import ResourceEdit from './components/crud/ResourceEdit';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminRoute from './components/auth/AdminRoute';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Protected Routes */}
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/course/:courseId/graph" element={<ProtectedRoute><GraphView /></ProtectedRoute>} />
          <Route path="/resources/:resource" element={<ProtectedRoute><ResourceList /></ProtectedRoute>} />
          <Route path="/resources/:resource/create" element={<ProtectedRoute><ResourceCreate /></ProtectedRoute>} />
          <Route path="/resources/:resource/edit/:id" element={<ProtectedRoute><ResourceEdit /></ProtectedRoute>} />
          
          {/* Admin-only Routes */}
          <Route path="/admin/users" element={<AdminRoute><UserManagement /></AdminRoute>} />

          {/* Root redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          {/* Catch-all for any other route */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;